<template>
  <div class="container_box">
    <div class="head_box"></div>
    <div class="detail_cont">
      <!-- <div class="menu_text">
        产品服务 > 产品动态 ><span>正文</span>
      </div> -->
      <div class="content_main">
        <div class="detail_info">
          <div class="title_cont flex">
            <p class="bt_text">{{detailCont.name}}</p>
            <!-- <div class="img_show flex">
              <p class="img flex">
                <img src="@/assets/pc/news/shang.png" alt="">
                <span>2</span>
              </p>
              <p class="img flex">
                <img src="@/assets/pc/news/xia.png" alt="">
                <span></span>
              </p>
            </div> -->
          </div>
          <div class="time">{{detailCont.publish_time_text}}</div>

          <div class="conts_info">
            <div v-html="detailCont.content"></div>
          </div>
        </div>
        <div class="menu_text">
          <p class="title">最新动态</p>
          <ul>
            <li v-for="item in newsList" :key="item.id" @click="detailBtn(item.id)">{{item.name}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data(){
    return{
      detailId:'',
      detailCont:'',
      newsList:[],
    }
  },
  mounted(){
    this.detailId = this.$route.query.id
    this.getDetailData()
  },
  methods:{
   getDetailData(){
    this.$axios(`v1/news/detail?id=`+this.detailId).then(res=>{
      if(res.code==1){
        console.log(res)
        res.data.detail.content = res.data.detail.content.replace(
            /<img/gi,
            '<img style="max-width:100%;height:auto;"'
          );
        this.detailCont = res.data.detail 
        this.newsList = res.data.new_list 
      }
    })
   },
   detailBtn(id){
    this.detailId = id
    this.getDetailData()
   }
   
  }
};
</script>

<style lang="scss" scoped>
.container_box{
  background: #F7FBFC;
  margin-top: -84px;
  .head_box {
    background: #333;
    height: 80px;
    width: 100%;
    // position: fixed;
    // left: 0;
    // top: 0;
    z-index: 0;
  }

  .detail_cont{
    width: 1200px;
    margin: 0 auto 0;
    padding-top: 53px;
    .menu_text{
      font-size: 14px;
      color: #333;
      span{
        color: #316CFF;
      }
    }
    .content_main{
      display: flex;
      // margin-top: 27px;
     
      .detail_info{
        background: #fff;
        width: 871px;
        box-sizing: border-box;
        padding: 35px 45px 0 38px;
         padding-bottom: 67px;
        .title_cont{
          justify-content: space-between;
          .bt_text{
            font-size: 24px;
            color: #333333;
          }
          .img_show{
            p.img{
              margin-right: 8px;
              width: 68px;
              height: 30px;
              background: #EEF5F7;
              border-radius: 2px 2px 2px 2px;
              display: flex;
              align-content: center;
              justify-content: center;
            }
          }
        }
        .time{
          font-size: 12px;
          margin-top: 15px;
          color: #999999;
          margin-bottom: 15px;
        }
        .conts_info{
          border-top: 1px solid #EBECEC;
          padding-top: 15px;
          font-size: 14px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          div{
            // margin-top: 39px;
            p.title{
              font-size: 18px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #316CFF;
              margin-bottom: 14px;
            }
            p.text{

            }
          }
        }
      }
      .menu_text{
        margin-left: 25px;
        flex: 1;
        background: #fff;
        box-sizing: border-box;
        padding: 20px;
        height: 550px;
        overflow-y: auto;
        border-radius: 5px;
        p.title{
          font-size: 20px;
          color: #333333;
          border-bottom: 1px solid #EBECEC;
          padding-bottom: 22px;
        }
        ul{
          margin-top: 10px;
          li{
            margin-bottom: 26px;
            font-size: 14px;
            color: #333333;
            cursor: pointer;
          }
          li:hover{
            color: #316CFF;
          }
        }
      }
    }
  }
}
</style>